import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Widget from "@/pages/Widget";
import AgentConsole from "@/pages/AgentConsole";
import DashboardLayout from "@/pages/dashboard/DashboardLayout";
import Overview from "@/pages/dashboard/Overview";
import AgentsList from "@/pages/dashboard/AgentsList";
import AgentBuilder from "@/pages/dashboard/AgentBuilder";
import Conversations from "@/pages/dashboard/Conversations";
import CoPilot from "@/pages/dashboard/CoPilot";
import AnalyticsPage from "@/pages/dashboard/AnalyticsPage";
import AiInsights from "@/pages/dashboard/AiInsights";
import Integrations from "@/pages/dashboard/Integrations";
import Team from "@/pages/dashboard/Team";
import Compliance from "@/pages/dashboard/Compliance";
import Leads from "@/pages/dashboard/Leads";
import Costs from "@/pages/dashboard/Costs";
import KnowledgeGaps from "@/pages/dashboard/KnowledgeGaps";
import Quality from "@/pages/dashboard/Quality";
import Topics from "@/pages/dashboard/Topics";
import Telephony from "@/pages/dashboard/Telephony";
import Settings from "@/pages/dashboard/Settings";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/widget/:agentId" element={<Widget />} />
            <Route
              path="/agent"
              element={
                <ProtectedRoute>
                  <AgentConsole />
                </ProtectedRoute>
              }
            />
            <Route
              path="/app"
              element={
                <ProtectedRoute>
                  <DashboardLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Overview />} />
              <Route path="agents" element={<AgentsList />} />
              <Route path="agents/:agentId" element={<AgentBuilder />} />
              <Route path="conversations" element={<Conversations />} />
              <Route path="copilot" element={<CoPilot />} />
              <Route path="knowledge-gaps" element={<KnowledgeGaps />} />
              <Route path="analytics" element={<AnalyticsPage />} />
              <Route path="quality" element={<Quality />} />
              <Route path="topics" element={<Topics />} />
              <Route path="telephony" element={<Telephony />} />
              <Route path="ai-insights" element={<AiInsights />} />
              <Route path="integrations" element={<Integrations />} />
              <Route path="team" element={<Team />} />
              <Route path="compliance" element={<Compliance />} />
              <Route path="leads" element={<Leads />} />
            <Route path="costs" element={<Costs />} />
              <Route path="settings" element={<Settings />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
